class BuildYourBundleCart extends HTMLElement {
  constructor() {
    super();

    this.collectionId = this.dataset.collection;
    this.translations = this.extractTranslations();
    this.currency = window.Shopify.currency.active;
    this.errorMessage = null;
    this.productsInBundle = [];
    this.bundleQuantity = 0;
    this.bundleName = "";
    this.selectedVariant = null;
    this.bundlePrice = 0;
    this.mhkd = 0;
    this.cpp = 0;
    this.mpc = 0;
    this.mpcd = 0;
    this.overlay = document.getElementById("byb_overlay");

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.facet = document.querySelector("byb-facet-filters-form");
    this.onLoad();

    this.closeButton = document.getElementById("close-byb-cart");
    this.openButton = document.getElementById("open-byb-cart");
    this.closeButton.addEventListener("click", () => this.toggleCart());
    this.openButton.addEventListener("click", () => this.toggleCart());



    // Event listener for clicking on empty bundle items to close the cart
    document.addEventListener("click", (event) => {
      if (event.target.classList.contains("byb-bundle-item-empty")) {
        this.toggleCart();
      }
    });
  }

  hideOverlay() {
    if (this.overlay) {
      this.overlay.classList.add("!hidden");
    }
  }

  formatMoney(amount) {
    if (this.currency === 'SEK') {
      return (typeof amount === 'number' ? amount : Number(amount)).toFixed(2).replace('.', ',') + ' kr';
    }
    return (typeof amount === 'number' ? amount : Number(amount)).toFixed(2) + ' ' + this.currency;
  }

  isMobile() {
    return window.innerWidth <= 768;
  }

  async onLoad() {
    this.formCatch();
    this.initSizeSyncOnTileClick();
    await this.fetchDiscounts();
    this.insertBundleQuantity();
    this.insertBundleQuantityInUspGrid();
    this.insertBundlePriceInUspGrid();
    this.updateBundleUI();
    this.disableLoading();
  }

  /**
   * When a size tile is clicked on any bundle card, sync that size
   * to all other cards that don't already have a selection.
   */
  initSizeSyncOnTileClick() {
    document.addEventListener('click', (e) => {
      // Single-option tile
      const sizeTile = e.target.closest('.card-size-tile');
      if (sizeTile && !sizeTile.dataset.unavailable) {
        const form = sizeTile.closest('.bundle-form');
        if (!form) return;
        const variantTitle = sizeTile.dataset.variantTitle || sizeTile.textContent.trim();
        if (variantTitle) this.syncSizeToOtherCards(variantTitle, form);
        return;
      }

      // Multi-option tile (pants: waist/length)
      const optTile = e.target.closest('.card-option-tile');
      if (optTile && !optTile.dataset.unavailable) {
        const form = optTile.closest('.bundle-form');
        if (!form) return;
        // Only sync once both options are selected
        const wrapper = optTile.closest('[data-pants-card]');
        if (!wrapper) return;
        const groups = wrapper.querySelectorAll('.card-option-group');
        const parts = [];
        let allSelected = true;
        groups.forEach(g => {
          const active = g.querySelector('.card-option-tile.card-tile-active');
          if (active) parts.push(active.dataset.optionValue);
          else allSelected = false;
        });
        if (allSelected && parts.length >= 2) {
          this.syncSizeToOtherCards(parts.join(' / '), form);
        }
      }
    });
  }

  syncSizeToOtherCards(variantTitle, sourceForm) {
    if (!variantTitle) return;
    const isPantsVariant = variantTitle.includes('/');
    const forms = document.querySelectorAll('.bundle-form');

    forms.forEach(form => {
      if (form === sourceForm) return;

      const overlay = form.querySelector('.xy-card-size-overlay');
      if (!overlay) return;

      // Skip if this card already has a size selected
      if (overlay.querySelector('.card-tile-active')) return;

      const select = form.querySelector('select[name="id"]');
      if (!select) return;
      const isPantsCard = select.dataset.pantsCard === 'true';

      // Only match same type (pants→pants, regular→regular)
      if (isPantsVariant !== isPantsCard) return;

      if (isPantsCard) {
        const parts = variantTitle.split('/').map(p => p.trim());
        if (parts.length < 2) return;

        const waistGroup = overlay.querySelector('.card-option-group[data-option-index="0"]');
        if (waistGroup) {
          const wTile = waistGroup.querySelector('.card-option-tile[data-option-value="' + parts[0] + '"]');
          if (wTile && !wTile.dataset.unavailable) {
            waistGroup.querySelectorAll('.card-option-tile').forEach(t => {
              t.classList.remove('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
              t.classList.add('bg-white', 'border-border');
            });
            wTile.classList.add('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
            wTile.classList.remove('bg-white', 'border-border');
          }
        }

        const lenGroup = overlay.querySelector('.card-option-group[data-option-index="1"]');
        if (lenGroup) {
          const lTile = lenGroup.querySelector('.card-option-tile[data-option-value="' + parts[1] + '"]');
          if (lTile && !lTile.dataset.unavailable) {
            lenGroup.querySelectorAll('.card-option-tile').forEach(t => {
              t.classList.remove('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
              t.classList.add('bg-white', 'border-border');
            });
            lTile.classList.add('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
            lTile.classList.remove('bg-white', 'border-border');
          }
        }

        const opts = Array.from(select.options);
        const exact = opts.find(o => o.dataset.waist === parts[0] && o.dataset.length === parts[1] && !o.disabled);
        if (exact) select.value = exact.value;
      } else {
        const tiles = overlay.querySelector('.card-size-tiles');
        if (!tiles) return;

        // Find tile matching the variant title
        let matchTile = tiles.querySelector('.card-size-tile[data-variant-title="' + variantTitle + '"]');
        if (!matchTile) {
          // Fallback: match by text content
          tiles.querySelectorAll('.card-size-tile').forEach(t => {
            if (t.textContent.trim() === variantTitle && !t.dataset.unavailable) matchTile = t;
          });
        }

        if (matchTile && !matchTile.dataset.unavailable) {
          tiles.querySelectorAll('.card-size-tile').forEach(t => {
            t.classList.remove('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
            t.classList.add('bg-white', 'border-border');
          });
          matchTile.classList.add('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
          matchTile.classList.remove('bg-white', 'border-border');
          if (matchTile.dataset.variantId) select.value = matchTile.dataset.variantId;
        }
      }
    });
  }

  formCatch() {
    if (this.forms && this.forms.length > 0) {
      // Unsubscribe from all events
    }
  
    // Get all forms
    this.forms = document.getElementsByClassName("bundle-form");
  
    for (let i = 0; i < this.forms.length; i++) {
      this.forms[i].addEventListener("submit", async (event) => {
        event.preventDefault();
        await this.addToCart(event, this.forms[i]);
  
        // Check if the last product is being added
        const isLastProduct = this.productsInBundle.length === this.bundleQuantity;
  
        // Scroll to the top if not the last item or if on desktop
        if (!isLastProduct || !this.isMobile()) {
          window.scrollTo(0, 0);
        }
  
        // Toggle the cart only if the last item is added
        if (isLastProduct) {
          this.toggleCart();
        }
      });
    }
  }
  

  handleIntersectionAfterSubmit() {
    const animationTriggerElements = Array.from(
      document.querySelectorAll(`.${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`)
    );
    animationTriggerElements.forEach((element) => {
      if (
        element.isIntersecting &&
        element.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
      ) {
        element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (element.hasAttribute("data-cascade")) {
          const index = animationTriggerElements.indexOf(element);
          element.setAttribute("style", `--animation-order: ${index};`);
        }
      }
    });
  }

  insertBundleQuantityInUspGrid() {
    // Find all ".bundle-qty" elements and update their text content
    const bundleQtyElements = document.querySelectorAll(".bundle-qty");
    bundleQtyElements.forEach((bundleQtyElement) => {
      bundleQtyElement.textContent = this.bundleQuantity;
    });
  }

  insertBundlePriceInUspGrid() {
    // Find the single element with class "usp-grid"
    const uspGridElement = document.querySelector(".usp-grid");

    if (uspGridElement) {
      // Find all ".bundle-price" elements within the "usp-grid" and update their text content
      const bundlePriceElements =
        uspGridElement.querySelectorAll(".bundle-price");
      bundlePriceElements.forEach((bundlePriceElement) => {
        bundlePriceElement.textContent = this.formatMoney(this.bundlePrice);
      });
    }
  }

  insertBundleQuantity() {
    // Find the .byb-qty element
    const qtyElement = document.querySelector(".byb-qty");

    // If the .byb-qty element exists, set its text content to bundleQuantity
    if (qtyElement) {
      qtyElement.textContent = this.bundleQuantity;
    }
  }

  
  

  handleProductCardButtonClick() {
    document.querySelectorAll('.product_card .Button_primary').forEach(button => {
      button.addEventListener('click', (e) => {

      });
    });
  }

  renderCartDetail() {
    // calculate before - use compare_at_price if available (> 0) and greater than price
    const beforePrice = this.productsInBundle.reduce((acc, product) => {
      return acc + (product.compare_at_price > 0 && product.compare_at_price > product.price ? product.compare_at_price : product.price);
    }, 0);

    // calculate saved based on bundle price and before price
    const savedProcent =
      beforePrice !== 0
        ? Math.round(100 - (this.bundlePrice / beforePrice) * 100)
        : 0;
    const container = document.getElementById("byb_cart_details");
    if (!container) return;

    let buttonText = this.translations.add_bundle_to_cart;
    let buttonClass = "Button Button_secondary"; // Default to secondary class

    // Calculate the remaining quantity needed to reach bundleQuantity
    const remainingQuantity =
      this.bundleQuantity - this.productsInBundle.length;

    // Check if the total amount has been reached
    if (remainingQuantity === 0) {
      // If the total amount has been reached, switch to primary class
      buttonClass = "Button Button_primary";
    } else if (remainingQuantity > 0) {
      buttonText = `${this.translations.select} ${remainingQuantity} ${
        this.translations.more
      } ${
        remainingQuantity === 1
          ? this.translations.item
          : this.translations.items
      }`;
    }
  }

  addToCart(event, form) {
    if (this.productsInBundle.length >= this.bundleQuantity) {
        return;
    }

    const formData = new FormData(form);
    const c = this.extractHkd(formData);

    // Get the selected option element from the form
    const selectedOption = form.querySelector(
        'select[name="id"] option:checked'
    );
    const variantTitle = selectedOption
        ? selectedOption.getAttribute("data-variant-title")
        : "";

    const product = {
        id: formData.get("id"),
        properties: {
            _BundleCollection: this.collectionId,
            _BundleConfiguration: JSON.stringify({
                bundleQuantity: this.bundleQuantity,
                bundlePrice: this.bundlePrice,
                bundleName: this.bundleName,
                e_collection: btoa(this.collectionId),
            }),
        },
        title: formData.get("product_name"),
        price: Number(formData.get("price")) / 100,
        compare_at_price: Number(formData.get("compare_at_price")) / 100,
        image: formData.get("product_image"),
        variantTitle: variantTitle,
        hkd: c,
    };
    this.productsInBundle.push(product);
    this.syncProductsInBundleWithStorage();
    this.updateBundleUI();
    this.handleIntersectionAfterSubmit();
    this.preselectSizesOnCards(variantTitle, form);

    // Calculate the remaining quantity needed to reach bundleQuantity
    const remainingQuantity = this.bundleQuantity - this.productsInBundle.length;

    // Check if the total amount has not been reached
    if (remainingQuantity !== 0) {
        window.toggleClearFiltersButton();
    }
  }

  preselectSizesOnCards(variantTitle, submittedForm) {
    if (!variantTitle) return;

    const isPantsVariant = variantTitle.includes('/');
    const forms = document.querySelectorAll('.bundle-form');

    forms.forEach(form => {
      if (form === submittedForm) return;

      const select = form.querySelector('select[name="id"]');
      if (!select) return;

      const overlay = form.querySelector('.xy-card-size-overlay');
      if (!overlay) return;

      // Skip if this card already has a size selected
      if (overlay.querySelector('.card-tile-active')) return;

      const isPantsCard = select.dataset.pantsCard === 'true';

      // Only match pants→pants or regular→regular
      if (isPantsVariant !== isPantsCard) return;

      if (isPantsCard) {
        const parts = variantTitle.split('/').map(p => p.trim());
        if (parts.length < 2) return;
        const waist = parts[0];
        const length = parts[1];

        // Preselect waist tile
        const waistGroup = overlay.querySelector('.card-option-group[data-option-index="0"]');
        if (waistGroup) {
          const wTile = waistGroup.querySelector('.card-option-tile[data-option-value="' + waist + '"]');
          if (wTile && !wTile.dataset.unavailable) {
            waistGroup.querySelectorAll('.card-option-tile').forEach(t => {
              t.classList.remove('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
              t.classList.add('bg-white', 'border-border');
            });
            wTile.classList.add('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
            wTile.classList.remove('bg-white', 'border-border');
          }
        }

        // Preselect length tile if exact match exists
        const lenGroup = overlay.querySelector('.card-option-group[data-option-index="1"]');
        if (lenGroup) {
          const lTile = lenGroup.querySelector('.card-option-tile[data-option-value="' + length + '"]');
          if (lTile && !lTile.dataset.unavailable) {
            lenGroup.querySelectorAll('.card-option-tile').forEach(t => {
              t.classList.remove('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
              t.classList.add('bg-white', 'border-border');
            });
            lTile.classList.add('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
            lTile.classList.remove('bg-white', 'border-border');
          }
        }

        // Set select to exact variant if both waist+length match
        const opts = Array.from(select.options);
        const exact = opts.find(o => o.dataset.waist === waist && o.dataset.length === length && !o.disabled);
        if (exact) select.value = exact.value;

      } else {
        // Regular sizes
        const opts = Array.from(select.options);
        const match = opts.find(o => o.dataset.variantTitle === variantTitle && !o.disabled);
        if (!match) return;

        const tiles = overlay.querySelector('.card-size-tiles');
        if (!tiles) return;

        const tile = tiles.querySelector('.card-size-tile[data-variant-title="' + variantTitle + '"]');
        if (tile && !tile.dataset.unavailable) {
          tiles.querySelectorAll('.card-size-tile').forEach(t => {
            t.classList.remove('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
            t.classList.add('bg-white', 'border-border');
          });
          tile.classList.add('card-tile-active', 'bg-primary-black', 'text-white', 'border-primary-black');
          tile.classList.remove('bg-white', 'border-border');
          select.value = match.value;
        }
      }
    });
  }

  removeProductFromBundle(product) {
      this.productsInBundle = this.productsInBundle.filter(
          (p) => p.id !== product.id
      );
      this.syncProductsInBundleWithStorage();
      this.updateBundleUI();

      // Calculate the remaining quantity needed to reach bundleQuantity
      const remainingQuantity = this.bundleQuantity - this.productsInBundle.length;

      // Check if the total amount has not been reached
      if (remainingQuantity !== 0) {
          window.toggleClearFiltersButton();
      }
  }

  toggleCart() {
    const isCartHidden = this.classList.contains("hidden");
  
    if (isCartHidden) {
      // Show the cart
      this.classList.remove("hidden");
  
      // Apply no-scroll if there are more than 5 products and on mobile
      if (this.isMobile()) {
        document.body.classList.add("body-no-scroll");
      }
    } else {
      // Hide the cart
      this.classList.add("hidden");
  
      // Remove no-scroll class only if the cart was originally open
      if (this.isMobile()) {
        if (document.body.classList.contains("body-no-scroll")) {
          document.body.classList.remove("body-no-scroll");
        }
      }
    }
  }
  

  updateBundleUI() {
    const list = document.getElementById("byb_product_list");
    if (!list) return;

    // Clear the list
    list.innerHTML = "";

    // Calculate how many empty placeholders to add
    const emptyPlaceholderCount =
      this.bundleQuantity - this.productsInBundle.length;

    // Add actual products to the list, replacing the initial 3
    this.productsInBundle.forEach((product, index) => {
      // Added 'index' parameter
      const li = document.createElement("li");
      li.dataset.id = product.id;
      li.classList.add("byb-bundle-item", "text-sm", "relative");

      li.innerHTML = `
          <div class="byb-cart-item flex items-center justify-between gap-2 bg-white rounded-sm overflow-hidden">
            <button class="byb-remove-bundle-item absolute text-xs ">${
              this.translations.Remove
            }</button>
            <img height="100" class="object-cover min-h-[80px] h-full" src="${
              product.image
            }" alt="${product.title}" />
            <div class="flex flex-col gap-2 pr-2 w-full">
              <span class="Heading font-bold text-sm">${
                product.title.trim().length > 22
                  ? product.title.trim().substring(0, 22) + "..."
                  : product.title.trim()
              }</span>
                <span class="flex flex-row item-center justify-between gap-x-2">
                ${
                  product.variantTitle
                    ? `<span class="text-sm">Size: ${product.variantTitle}</span>`
                    : ""
                }
                <span class="byb-before-price text-sm line-through">${
                  this.formatMoney(product.compare_at_price > 0 && product.compare_at_price > product.price ? product.compare_at_price : product.price)
                }</span>
              </span>
            </div>
          </div>
          `;

      li.addEventListener("click", (event) => {
        if (event.target.classList.contains("byb-remove-bundle-item")) {
          // Find the index of the clicked product
          const clickedIndex = this.productsInBundle.findIndex(
            (p) => p.id === product.id
          );
          // Remove only the clicked product
          if (clickedIndex !== -1) {
            this.productsInBundle.splice(clickedIndex, 1);
            this.syncProductsInBundleWithStorage();
            this.updateBundleUI(); // Re-render the UI after removing the product
          }
        }
      });

      list.appendChild(li);
    });

    // Add any remaining empty placeholders, if needed
    for (let i = 0; i < emptyPlaceholderCount; i++) {
      const emptyLi = document.createElement("li");
      emptyLi.classList.add("byb-bundle-item-empty");
      emptyLi.innerHTML = `
          <div class="empty-content flex flex-row md:flex-col items-center justify-center">
            <img width="45" loading="lazy" src="https://teeshoppen-group.myshopify.com/cdn/shop/files/bundle_150x.svg" alt="Bundle" />
            <span class="text-sm text-gray-400">${this.translations.empty_item}</span>
          </div>
          `;
      list.appendChild(emptyLi);
    }

    this.calculateMpcd();
    this.updateAvailableProducts();
    this.renderCartDetail();
    this.applyContainerStyles();
  }

  applyContainerStyles() {
    const container = document.querySelector(".byb-products-container");
    if (container && this.isMobile()) {
      if (this.productsInBundle.length >= 5) {
        container.style.overflowY = "scroll";
        container.style.maxHeight = "300px";
        container.style.alignItems = "flex-start";
      } else {
        container.style.overflowY = "visible";
        container.style.maxHeight = "unset";
      }
    }
  }

  renderCartDetail() {
    // calculate before - use compare_at_price if available (> 0) and greater than price
    const beforePrice = this.productsInBundle.reduce((acc, product) => {
      return acc + (product.compare_at_price > 0 && product.compare_at_price > product.price ? product.compare_at_price : product.price);
    }, 0);

    // calculate saved based on bundle price and before price
    const savedProcent =
      beforePrice !== 0
        ? Math.round(100 - (this.bundlePrice / beforePrice) * 100)
        : 0;
    const container = document.getElementById("byb_cart_details");
    if (!container) return;

    let buttonText = this.translations.add_bundle_to_cart;
    let buttonClass = "Button Button_secondary"; // Default to secondary class

    // Calculate the remaining quantity needed to reach bundleQuantity
    const remainingQuantity =
      this.bundleQuantity - this.productsInBundle.length;

    // Check if the total amount has been reached
    if (remainingQuantity === 0) {
      // If the total amount has been reached, switch to primary class
      buttonClass = "Button Button_primary";
    } else if (remainingQuantity > 0) {
      buttonText = `${this.translations.select} ${remainingQuantity} ${
        this.translations.more
      } ${
        remainingQuantity === 1
          ? this.translations.item
          : this.translations.items
      }`;
    }

    // Calculate the amount selected
    let amountSelected = 0;

    amountSelected = this.bundleQuantity - remainingQuantity;

    // Update the innerHTML of the .bundle-count span
    const bundleCountSpan = document.querySelector(".bundle-count");
    if (bundleCountSpan) {
      bundleCountSpan.innerHTML = amountSelected;
    }

    // Add .bundle_full to .bundlecart_button when no more to select
    const bundleCartButton = document.querySelector(".bundlecart_button");
    if (remainingQuantity === 0 && bundleCartButton) {
      bundleCartButton.classList.add("bundle_full");
    }

    container.innerHTML = `
      <div class="byb-cart-price flex flex-col gap-y-[5px] pb-2 mb-2">
          <span class="Heading byb-your-price flex justify-between text-2xl font-bold pb-1 ">${
            this.translations.your_price
          }: <span class="text-red-500">${this.formatMoney(this.bundlePrice)}</span></span>
          <span class="byb-before-price line-through flex justify-between">${
            this.translations.before_price
          }: <span class="0">${this.formatMoney(beforePrice)}</span></span>
          <span class="byb-saved flex item justify-between">${
            this.translations.saving
          }: <span class="bg-red-500 text-sm rounded-sm px-2 py-1 text-white" style="line-height: 0.75rem;">${savedProcent}%</span></span>
      </div>
      <a href="#" id="add_bundle_to_cart" class="${buttonClass} w-full mt-4">${buttonText}</a>
      `;

    const addToCartButton = document.getElementById("add_bundle_to_cart");
    addToCartButton.addEventListener("click", (event) => {
      event.preventDefault();
      if (remainingQuantity > 0) {
        // Handle the case where the remaining items need to be selected

        this.toggleCart();
      } else {
        // Handle the case where the bundle can be added to the cart
        this.addBundleToCart();
        this.toggleCart();
      }
    });
  }

  hideCartDetails() {
    const container = document.getElementById("byb_cart_details");
    if (!container) return;
    container.innerHTML = "";
  }

  extractHkd(formData) {
    const x = atob("WTI5emRB");
    const y = String(formData.get(x));
    const z = atob(y);
    return Number(z) / 8;
  }

  extractMhkd(mhkd) {
    const z = atob(mhkd);
    return Number(z) / 8;
  }

  cartIsOverLimit() {
    const thkd = this.productsInBundle.reduce((acc, product) => {
      return acc + product.hkd;
    }, 0);

    let dhkd = this.mhkd - thkd;

    if (dhkd < 0) {
      alert("Something is wrong with the cart. Please try other products");
      return true;
    }

    return false;
  }

  async addBundleToCart() {
    if (this.cartIsOverLimit()) return;

    const dataToSend = this.productsInBundle.map(function (product) {
      // Push the data for each product to the array
      return {
        id: product.id,
        quantity: 1,
        properties: product.properties,
      };
    });

    const ajax = window.liquidAjaxCart;

    this.enableLoading();

    const options = {
      firstCallback: (requestState) => {
        this.addToCardSuccesCallback(requestState);

        // Remove the loading overlay
        this.disableLoading();

        // Open the cart
        document.body.classList.add("js-show-ajax-cart");

        if (
          !document.documentElement.classList.contains("js-ajax-cart-empty")
        ) {
          document
            .querySelector("#shopify-section-cart-recomendations")
            .classList.add("cart-recom-slidein");
        } else {
          document
            .querySelector("#shopify-section-cart-recomendations")
            .classList.remove("cart-recom-slidein");
        }
      },
    };

    ajax.add(
      {
        items: dataToSend, // Wrap the array in an object with a key "items"
      },
      options
    );
  }

  addToCardSuccesCallback(response) {
    this.disableLoading();
    if (response.responseData.status !== 200) {
      this.disableLoading();
      console.log("cart error", response);
      return;
    }
    this.productsInBundle = [];
    this.syncProductsInBundleWithStorage();
    this.updateBundleUI();
  }

  extractTranslations() {
    let trans = this.replaceAll(this.dataset.translations, "=>", ":");
    trans = this.replaceAll(trans, "u0026quot;", '"');
    trans = this.replaceAll(trans, "=u0026gt;", ":");

    return JSON.parse(trans);
  }

  replaceAll(str, find, replace) {
    const string = str.replace(new RegExp(find, "g"), replace);
    return string.replace(/\\/g, "");
  }

  async fetchDiscounts() {
    this.enableLoading();
    const scriptConf = this.querySelector("script[data-configuration-json]");
    const configuration = JSON.parse(scriptConf?.innerHTML);

    this.bundleQuantity = configuration.quantity;
    this.bundlePrice = configuration.bundlePrice;
    this.bundleName = configuration.bundleName;
    this.mhkd = this.extractMhkd(configuration.mhkd);
    this.cpp = configuration.cpp;

    if (this.cpp === null || this.cpp === 0) {
      this.calculateCheapestCpp();
    }

    this.fetchProductsInBundleWithStorage();
    this.calculateMpc();

    this.disableLoading();
  }

  enableLoading() {
    const loader = document.getElementById("byb_overlay");
    loader?.classList.remove("!hidden");
  }

  disableLoading() {
    const loader = document.getElementById("byb_overlay");
    loader?.classList.add("!hidden");
  }

  syncProductsInBundleWithStorage() {
    // create dummy event
    const storageData = {
      productsInBundle: this.productsInBundle,
    };
    localStorage.setItem(
      "byb_products_in_bundle_" + this.collectionId,
      JSON.stringify(storageData)
    );
  }

  fetchProductsInBundleWithStorage() {
    // create dummy event
    const storageData = localStorage.getItem(
      "byb_products_in_bundle_" + this.collectionId
    );
    if (!storageData) return;

    const parsedData = JSON.parse(storageData);
    this.productsInBundle = parsedData.productsInBundle;
    this.calculateMpc();
    this.updateBundleUI();
  }

  calculateCheapestCpp() {
    const grid = document.querySelector("#product-grid");
    const products = grid?.querySelectorAll(".Product-item");

    const prices = [];

    products?.forEach((product) => {
      const productForm = product.querySelector("form");
      const formData = new FormData(productForm);

      const hkd = this.extractHkd(formData);
      prices.push(hkd);
    });

    this.cpp = Math.min(...prices);
    return this.cpp;
  }

  // MPC product algorithm
  calculateMpc() {
    const cbd = this.mhkd - this.cpp * this.bundleQuantity;
    this.mpc = this.cpp + cbd;
    this.mpcd = this.mpc;
  }

  // MPCD continuous product algorithm
  calculateMpcd() {
    const remainingProductsQty =
      this.bundleQuantity - this.productsInBundle.length;

    const thkd = this.productsInBundle.reduce((acc, product) => {
      return acc + product.hkd;
    }, 0);

    const cbdRemaining = this.mhkd - thkd - this.cpp * remainingProductsQty;
    this.mpcd = this.cpp + cbdRemaining;
  }

  updateAvailableProducts() {
    const grid = document.querySelector("#product-grid");

    const thkd = this.productsInBundle.reduce((acc, product) => {
      return acc + product.hkd;
    }, 0);

    // console.log("thkd", thkd);

    let dhkd = this.mhkd - thkd;

    dhkd = dhkd - this.cpp; // Subtract the cheapest product price

    if (dhkd < this.cpp) dhkd = this.cpp; // If the remaining budget is less than the cheapest product price, set it to the cheapest product price

    let mpcIndex = 0;
    let mpcdIndex = 0;

    const products = grid?.querySelectorAll(".Product-item");
    products?.forEach((product) => {
      const productForm = product.querySelector("form");
      const formData = new FormData(productForm);
      const productId = formData.get("id");
      const hkd = this.extractHkd(formData);

      // Check if the product is already in the bundle
      const inCart = this.productsInBundle.find((p) => p.id === productId);

      // Check if the product's price exceeds the remaining budget or max product cost
      const exceedsBudget = hkd > dhkd || hkd > this.mpc || hkd > this.mpcd;

      //   if (hkd > this.mpc) {
      //     console.log(
      //       "product mpc removed " + this.mpc,
      //       formData.get("product_name"),
      //       "hkd",
      //       hkd
      //     );
      //     mpcIndex++;
      //   }
      //   if (hkd > this.mpcd && hkd >= dhkd) {
      //     console.log(
      //       "product mpcd removed " + this.mpcd,
      //       formData.get("product_name"),
      //       "hkd",
      //       hkd,
      //       dhkd
      //     );
      //     mpcdIndex++;
      //   }

      // Add event listener to the remove button
      const removeButton = product.querySelector(".byb-remove-bundle-item");

      if (removeButton) {
        removeButton.addEventListener("click", () => {
          // Remove the product from the bundle
          const clickedProductIndex = this.productsInBundle.findIndex(
            (p) => p.id === productId
          );
          if (clickedProductIndex !== -1) {
            this.productsInBundle.splice(clickedProductIndex, 1);
            this.syncProductsInBundleWithStorage();
            this.updateBundleUI();
          }
        });
      }

      // Hide the product if it's in the bundle or its price exceeds the remaining budget
      if (exceedsBudget) {
        product.classList.add("hide");
      } else {
        product.classList.remove("hide");
      }
    });

    // console.log("mpcIndex", mpcIndex);
    // console.log("mpcdIndex", mpcdIndex);
  }
}
customElements.define("build-your-bundle-cart", BuildYourBundleCart);
